import { Stack } from 'expo-router';
import React from 'react';

function CreditScoreLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default CreditScoreLayout;
